<template>
  <div v-if="facts" class="tc-source-facts" data-testid="source-facts">
    <span
      v-for="tag in facts.tags"
      :key="tag"
      class="tc-source-facts-tag"
      :title="tag"
      data-testid="source-facts-tag"
    >{{ tag }}</span>
    <span v-if="facts.tagOverflow > 0" class="tc-source-facts-more" data-testid="source-facts-more">
      +{{ facts.tagOverflow }}
    </span>
    <!-- Informational facts read as one clause, in the voice of the timestamp. -->
    <span
      v-if="facts.quiet.length > 0"
      class="tc-source-facts-quiet"
      data-testid="source-facts-quiet"
    >{{ facts.quiet.join(' · ') }}</span>
    <span
      v-for="flag in facts.flags"
      :key="flag"
      class="tc-source-facts-chip"
      data-testid="source-facts-flag"
    >{{ flag }}</span>
  </div>
</template>

<script setup lang="ts">
import type { SourceFacts } from '../sourceFacts';

defineProps<{ facts: SourceFacts | null }>();
</script>
